import type { RashiId } from "@ishvaram/domain-data/rashis";

import RashifalHubCheckLazy from "./RashifalHubCheckLazy";
import { RASHIFAL_HUB_CHECK_ID } from "./rashifal-hub-check-form";

/**
 * "Which rashi is yours?", answered right below the studio on /rashifal/ and
 * /hi/aaj-ka-rashifal/. Each studio reading is for a Chandra rashi, and many
 * readers mean their Western Sun sign, so the lead is the daily sign pages'
 * own sentence (RashiSignPage's check section). The answer opens the reader's
 * sign in the studio. The heading and lead are in the server HTML; the slot
 * (RashifalHubCheckLazy) loads the check on the reader's first press, focus or
 * submit.
 */

const COPY = {
  en: {
    heading: "Which rashi is yours?",
    lead: "Your rashi is your Chandra rashi: the sign the Moon was in when you were born, which is often not your Western Sun sign. Enter your birth details to find it, then open its reading for today in the studio above.",
    headingClass: "font-serif text-title font-bold text-text-primary",
  },
  hi: {
    heading: "आपकी राशि कौन-सी है?",
    lead: "आपकी राशि आपकी चन्द्र राशि है: आपके जन्म के समय चन्द्रमा जिस राशि में था। यह अक्सर आपकी पश्चिमी सूर्य राशि से अलग होती है। अपना जन्म विवरण डालें और ऊपर अपनी राशि का आज का फल खोलें।",
    headingClass: "font-hi text-title-hi font-bold text-text-primary",
  },
} as const;

export interface RashifalHubCheckSectionProps {
  /** /hi/aaj-ka-rashifal/ (the studio's own flag). */
  isHindi: boolean;
  /** Opens a sign's reading in the studio above (DailyGocharRashifalStudio). */
  onOpenRashi: (rashi: RashiId) => void;
}

export default function RashifalHubCheckSection({
  isHindi,
  onOpenRashi,
}: RashifalHubCheckSectionProps) {
  const language = isHindi ? "hi" : "en";
  const copy = COPY[language];
  return (
    <section
      id={RASHIFAL_HUB_CHECK_ID}
      aria-labelledby={`${RASHIFAL_HUB_CHECK_ID}-heading`}
      className="mb-8"
      data-rashifal-hub-check=""
    >
      <div className="mx-auto mb-5 max-w-xl text-center">
        <h2 id={`${RASHIFAL_HUB_CHECK_ID}-heading`} className={copy.headingClass}>
          {copy.heading}
        </h2>
        <p className="mt-2 text-body-small leading-relaxed text-text-secondary">{copy.lead}</p>
      </div>
      <RashifalHubCheckLazy language={language} onOpenRashi={onOpenRashi} />
    </section>
  );
}
